import { expectGameContext, expectScene } from "../util";
import { SceneId } from "../gameData";
import { playSceneVideo } from "./playSceneVideo";

export interface SwitchSceneOptions {
    didPop: boolean;
}

const DEFAULT_SWITCH_SCENE_OPTS: SwitchSceneOptions = {
    didPop: false,
};

export function switchScene(
    sceneId: SceneId,
    optsArg?: Partial<SwitchSceneOptions>,
) {
    const opts = {
        ...DEFAULT_SWITCH_SCENE_OPTS,
        ...optsArg,
    };

    const ctx = expectGameContext();
    const scene = expectScene(sceneId);

    ctx.gameState.currentSceneId = sceneId;
    if (!opts.didPop) {
        ctx.gameState.visitedScenes.add(sceneId);
        ctx.gameState.sceneHistory.push(sceneId);
    }

    playSceneVideo(scene);
}

export function popSceneHistory() {
    const ctx = expectGameContext();
    ctx.gameState.sceneHistory.pop();
    const prevScene =
        ctx.gameState.sceneHistory[ctx.gameState.sceneHistory.length - 1];
    if (!prevScene) {
        throw new Error("Failed to pop scene history, no previous scene");
    }
    switchScene(prevScene, { didPop: true });
}
